// extracted by mini-css-extract-plugin
module.exports = {"container":"purify_cardTitle__container--2JPiB","bottomRow":"purify_cardTitle__bottomRow--29MEB","cardTitle":"purify_cardTitle__cardTitle--RPsPT"};